// Temps et vitesses du lecteur vidéo, écrits à la française (TF-444).

const deuxChiffres = (valeur: number) => String(valeur).padStart(2, '0');

/** « 6:42 », « 1:02:05 ». */
export function tempsLisible(secondes: number): string {
  const total = Number.isFinite(secondes) && secondes > 0 ? Math.floor(secondes) : 0;
  const heures = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const reste = total % 60;
  return heures > 0 ? `${heures}:${deuxChiffres(minutes)}:${deuxChiffres(reste)}` : `${minutes}:${deuxChiffres(reste)}`;
}

export function tempsParle(secondes: number): string {
  const total = Number.isFinite(secondes) && secondes > 0 ? Math.floor(secondes) : 0;
  const minutes = Math.floor(total / 60);
  const reste = total % 60;
  return minutes > 0 ? `${minutes} min ${reste} s` : `${reste} s`;
}

export function vitesseLisible(vitesse: number): string {
  return `${String(vitesse).replace('.', ',')}×`;
}
